import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { volumeBenefits } from '../../data/salesContent';
export function VolumeBenefitsSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-236" data-mp="hvw739t84kaa">
      <div className="mx-auto max-w-6xl" data-id="element-237" data-mp="wneuhsoexh3o">
        <SectionHeading title="Cada volumen está pensado para que puedas volver a usarlo" data-id="element-238" data-mp="wog7w3swifok" />
        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-239" data-mp="rttu5tzckb1b">
          {volumeBenefits.map(({
          title,
          body,
          icon: Icon
        }) => <li key={title} className="flex flex-col rounded-2xl border border-ink-line bg-ink-raised p-7" data-id="element-240" data-mp="11m9e2wu7f9ou">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/40 text-gold" data-id="element-241" data-mp="1flr1p8vrkgwm">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-242" data-mp="1anpj0p292jlo" />
              </span>
              <h3 className="mt-5 font-display text-lg font-extrabold uppercase leading-snug text-cream md:text-xl" data-id="element-243" data-mp="3hdx6qg26qg1u">{title}</h3>
              <p className="mt-3 text-base leading-relaxed text-neutral-400 md:text-lg" data-id="element-244" data-mp="3cflxa6fsy7k5">{body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}